// import { Component, OnInit } from '@angular/core';
import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { BoardResponseModel } from "src/app/model/BoardResponseModel";
import { Page } from "src/app/model/Page";
import { MasterService } from "src/app/services/master.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSort, Sort } from "@angular/material/sort";
import { DashboardResponseModel } from "src/app/model/DashboardResponseModel";
import { LiveAnnouncer } from "@angular/cdk/a11y";
import { ExcelExportService } from "src/app/services/excel-export.service";

@Component({
  selector: "app-secure-dashboard-list",
  templateUrl: "./dashboard-list.component.html",
  styleUrls: ["./dashboard-list.component.scss"],
})
export class DashboardListComponent implements OnInit, AfterViewInit {
  isLoadingReport: boolean = false;
  page: Page<DashboardResponseModel>;
  dataSource: MatTableDataSource<BoardResponseModel> = new MatTableDataSource();
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  schemeFilter: FormGroup = new FormGroup({});
  incomeFilter: FormGroup = new FormGroup({});
  categoryFilter: FormGroup = new FormGroup({});
  nocFilter: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  dataSourceLottery: MatTableDataSource<DashboardResponseModel> =
    new MatTableDataSource();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = [
    "applicationNo",
    "applicantName",
    "lottery",
    "SIC",
    "drawStatus",
    "flatDetails",
    "accepenceStatus",
    "POL",
    "NOC",
    "firstInstStatus",
    "insPaymentStatus",
    "DraftAllotment",
    "Allotment",
    "Possession",
    "pendingDoc",
  ];
  nocType: string[] = ["NOT APPLIED", "PENDING", "APPROVED", "REJECTED", "CANCEL_REQUESTED"];
  acceptType: string[] = [
    "PENDING",
    "ACCEPTED_TENEMENT",
    "SURRENDERED_TENEMENT",
  ];
  schemeList: string[] = [];

  incomeList: string[] = [];

  catogryList: string[] = [];

  lastRefreshDate : string;

  constructor(
    public dialog: MatDialog,
    private masterService: MasterService,
    private router: Router,
    private _snackBar: MatSnackBar,
    private _liveAnnouncer: LiveAnnouncer,
    private excelExportService: ExcelExportService
  ) { }

  ngAfterViewInit() {
    // console.log('ngAfterViewInit call');
    this.dataSourceLottery.sort = this.sort;
  }

  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    // console.log('announceSortChange call');
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  ngOnInit(): void {
    this.dataSourceLottery.sort = this.sort;
    // console.log('ngOnInit call');
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [Validators.required,Validators.minLength(2)]),
      nocFilter: new FormControl(localStorage.getItem("dashboard-view-nocFilter")),
      schemeFilter: new FormControl(localStorage.getItem("dashboard-view-schemeFilter")),
      accepenceStatusFilter: new FormControl(localStorage.getItem("dashboard-view-accepenceStatusFilter")),
      polFilter: new FormControl(localStorage.getItem("dashboard-view-polFilter")),
      allotmentFilter: new FormControl(localStorage.getItem("dashboard-view-allotmentFilter")),
      draftAllotmentFilter: new FormControl(localStorage.getItem("dashboard-view-draftAllotmentFilter")),
      insPaymentFilter: new FormControl(localStorage.getItem("dashboard-view-insPaymentFilter")),
      appDrawStatus: new FormControl(localStorage.getItem("dashboard-view-appDrawStatus")),
      incomeFilter: new FormControl(localStorage.getItem("dashboard-view-incomeFilter")),
      categoryFilter: new FormControl(localStorage.getItem("dashboard-view-categoryFilter")),
      possessionFilter: new FormControl(localStorage.getItem("dashboard-view-possessionFilter")),
      firstInstStatus: new FormControl(localStorage.getItem("dashboard-view-firstInstStatus"))
    });

    this.nocFilter = new FormGroup({
      nocFilter: new FormControl(),
    });

    this.onLoad();
  }

  resetFilter() {
    this.filterForm.controls["filterText"].setValue(null);
    this.filterForm.controls["nocFilter"].setValue(null);
    this.filterForm.controls["schemeFilter"].setValue(null);
    this.filterForm.controls["accepenceStatusFilter"].setValue(null);
    this.filterForm.controls["polFilter"].setValue(null);
    this.filterForm.controls["allotmentFilter"].setValue(null);
    this.filterForm.controls["draftAllotmentFilter"].setValue(null);
    this.filterForm.controls["insPaymentFilter"].setValue(null);
    this.filterForm.controls["appDrawStatus"].setValue(null);
    this.filterForm.controls["incomeFilter"].setValue(null);
    this.filterForm.controls["categoryFilter"].setValue(null);
    this.filterForm.controls["possessionFilter"].setValue(null);
    this.filterForm.controls["firstInstStatus"].setValue(null);

    localStorage.setItem("dashboard-view-nocFilter", "");
    localStorage.setItem("dashboard-view-schemeFilter", "");
    localStorage.setItem("dashboard-view-accepenceStatusFilter", "");
    localStorage.setItem("dashboard-view-polFilter", "");
    localStorage.setItem("dashboard-view-allotmentFilter", "");
    localStorage.setItem("dashboard-view-draftAllotmentFilter", "");
    localStorage.setItem("dashboard-view-insPaymentFilter", "");
    localStorage.setItem("dashboard-view-appDrawStatus", "");
    localStorage.setItem("dashboard-view-incomeFilter", "");
    localStorage.setItem("dashboard-view-categoryFilter", "");
    localStorage.setItem("dashboard-view-possessionFilter", "");
    localStorage.setItem("dashboard-view-firstInstStatus", "");

    this.page = null;
    this.dataSource = new MatTableDataSource();
    this.currentPage = 0;
    this.paginator.pageIndex = this.currentPage;
    this.paginator.length = 0;
    this.onLoad();
  }

  onChangeFirstInstStatus(value) {
    // // console.log(value);
    this.pageSize = 10;
    this.currentPage = 0;
    localStorage.setItem("dashboard-view-firstInstStatus", this.filterForm.value.firstInstStatus);
    this.onLoad();
  }

  onChangePossessionFilter(value) {
    // // console.log(value);
    this.pageSize = 10;
    this.currentPage = 0;
    localStorage.setItem("dashboard-view-possessionFilter", this.filterForm.value.possessionFilter);
    this.onLoad();
  }

  onChangeNocFilter(value) {
    // // console.log(value);
    this.pageSize = 10;
    this.currentPage = 0;
    localStorage.setItem("dashboard-view-nocFilter", this.filterForm.value.nocFilter);
    this.onLoad();
  }

  onChangeAccepenceStatusFilter(value) {
    // // console.log(value);
    this.pageSize = 10;
    this.currentPage = 0;
    localStorage.setItem("dashboard-view-accepenceStatusFilter", this.filterForm.value.accepenceStatusFilter);
    this.onLoad();
  }

  onChangeSchemeFilter(value) {
    // console.log(value);
    this.pageSize = 10;
    this.currentPage = 0;
    localStorage.setItem("dashboard-view- ", this.filterForm.value.schemeFilter);
    this.onLoad();
  }

  onChangeIncomeFilter(value) {
    // console.log(value);
    this.pageSize = 10;
    this.currentPage = 0;
    localStorage.setItem("dashboard-view-incomeFilter", this.filterForm.value.incomeFilter);
    this.onLoad();
  }

  onChangeCategoryFilter(value) {
    // console.log(value);
    this.pageSize = 10;
    this.currentPage = 0;
    localStorage.setItem("dashboard-view-categoryFilter", this.filterForm.value.categoryFilter);
    this.onLoad();
  }

  onChangePolFilter(value) {
    // console.log(value);
    this.pageSize = 10;
    this.currentPage = 0;
    localStorage.setItem("dashboard-view-polFilter", this.filterForm.value.polFilter);
    this.onLoad();
  }

  onChangeDraftAllotmentFilter(value) {
    // console.log(value);
    this.pageSize = 10;
    this.currentPage = 0;
    localStorage.setItem("dashboard-view-draftAllotmentFilter", this.filterForm.value.draftAllotmentFilter);
    this.onLoad();
  }

  onChangeAllotmentFilter(value) {
    // console.log(value);
    this.pageSize = 10;
    this.currentPage = 0;
    localStorage.setItem("dashboard-view-allotmentFilter", this.filterForm.value.allotmentFilter);
    this.onLoad();
  }

  onChangeInsPaymentFilter(value) {
    // console.log(value);
    this.pageSize = 10;
    this.currentPage = 0;
    localStorage.setItem("dashboard-view-insPaymentFilter", this.filterForm.value.insPaymentFilter);
    this.onLoad();
  }

  onChangeAppDrawStatus(value) {
    // console.log(value);
    this.pageSize = 10;
    this.currentPage = 0;
    localStorage.setItem("dashboard-view-appDrawStatus", this.filterForm.value.appDrawStatus);
    this.onLoad();
  }

  onLoad() {
    this.isLoading = true;
    this.masterService
      .fetchDashboardApplicationList(
        this.currentPage,
        this.pageSize,
        this.filterForm.value.filterText,
        this.filterForm.value.nocFilter,
        this.filterForm.value.schemeFilter,
        this.filterForm.value.accepenceStatusFilter,
        this.filterForm.value.polFilter,
        this.filterForm.value.allotmentFilter,
        this.filterForm.value.insPaymentFilter,
        this.filterForm.value.appDrawStatus,
        this.filterForm.value.incomeFilter,
        this.filterForm.value.categoryFilter,
        this.filterForm.value.possessionFilter,
        this.filterForm.value.draftAllotmentFilter,
        this.filterForm.value.firstInstStatus
      )
      .subscribe(
        (data) => {
          this.page = data.page;
          this.schemeList = data.schemeCode;
          this.incomeList = data.incomeGroupCode;
          this.catogryList = data.categoryCode;
          this.lastRefreshDate = data.lastRefreshDate;
          console.log(this.lastRefreshDate);
          this.dataSourceLottery = new MatTableDataSource(data.page.content);
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = data.page.totalElements;
          });
          this.isSearchDisabled = false;
          this.isLoading = false;
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
          this.isSearchDisabled = false;
        }
      );
  }

  fetchMIS() {
    this.isLoadingReport = true;
    this.masterService
      .fetchMISReport(
        this.filterForm.value.filterText,
        this.filterForm.value.nocFilter,
        this.filterForm.value.schemeFilter,
        this.filterForm.value.accepenceStatusFilter,
        this.filterForm.value.polFilter,
        this.filterForm.value.allotmentFilter,
        this.filterForm.value.insPaymentFilter,
        this.filterForm.value.appDrawStatus,
        this.filterForm.value.incomeFilter,
        this.filterForm.value.categoryFilter,
        this.filterForm.value.possessionFilter,
        this.filterForm.value.draftAllotmentFilter,
        this.filterForm.value.firstInstStatus
      )
      .subscribe(
        (data) => {
          this.isLoading = false;
          this.isLoadingReport = false;
          if(data.status === 'SUCCESS') {
            this.excelExportService.exportExcel(data.title, data.columnNames, 
              data.lst, data.columnWidths, data.generatedBy, data.generatedOn);
          }
          else {
            this.masterService.errorToast(data.errorMessage);
            this.isLoadingReport = false;
          }
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
          this.isLoadingReport = false;
        }
      );
  }

  onSearch() {
    if (this.filterForm.valid) {
      this.pageSize = 10;
      this.currentPage = 0;
      this.onLoad();
    } else {
      this._snackBar.open(
        "Please enter Filter text (minimum - 2 char) ",
        "Close",
        {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3 * 1000,
        }
      );
      this.isSearchDisabled = false;
    }
  }

  exportMIS() {
    this.isLoadingReport = true;
    this.masterService.exportMIS().subscribe(
      (data) => {
        this.isLoadingReport = false;
        if (data.status === "SUCCESS") {
          this.isLoadingReport = false;
          this.downloadFile(data.base64File, data.fileName);
        } else {
          this.errorToast(data.errorMessage);
          this.isLoadingReport = false;
        }
      },
      (error) => {
        this.isLoadingReport = false;
        this.errorToast(
          error?.error?.message ||
          error?.errorMessage ||
          error?.error?.errorMessage
        );
      }
    );
  }

  showScheme(o1: any, o2: any) {
    if (o1 && o2 && o1 == o2) {
      return o1;
    } else {
      return "";
    }
  }

  pageChanged(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onLoad();
  }

  async errorToast(errorMessage: string) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 3 * 1000,
    });
  }


  viewClassForStatus(status: string) {
    if (
      status === "DRAW_WINNER" ||
      status === "DRAW_WAITLIST_ACTIVATED" ||
      status === "PUBLISHED" ||
      status === "First installment payment received"
    ) {
      return "bg-blue-400";
    } else if (status === "PENDING" || status === "First installment partial payment received") {
      return "bg-yellow-400";
    } else if (status === "APPROVED") {
      return "bg-green-400";
    } else if (status === "NOT ALLOWED") {
      return "bg-orange-400";
    } else if (
      status === "SURRENDERED_TENEMENT" ||
      status === "DRAW_WINNER_SURRENDERED" ||
      status === "REJECTED"
    ) {
      return "bg-pink-500";
    } else if (status === "PAYMENT FULL DONE") {
      return "bg-green-400";
    } else if (status === "PAYMENT PARTIAL DONE" || status === 'ACCOUNT_OFFICER_APPROVAL_PENDING') {
      return "bg-orange-400";
    } else {
      return "bg-pink-200";
    }
  }

  downloadFile(base64: string | ArrayBuffer, fileName: string) {
    const src = `${base64}`;
    const link = document.createElement("a");
    link.href = src;
    link.download = fileName;
    link.click();

    link.remove();
  }

  async refresh() {
    this.resetFilter();
    this.masterService.refreshDashboard().subscribe(
      (data) => {
        console.log(data);
        if(data.status === 'FAILURE'){
          this.errorToast("Unable to refresh.");
        }

    },
    (error) => {
      console.log(error);
      this.isLoading = false;
      this.isSearchDisabled = false;
    }
    );

    setTimeout(() => {
      this.onLoad();
    }, 2000);
  }

  showObj(o1: any, o2: any) {    
    // console.log('showObj', o1, o2, o1 == o2); 
    if(o1 && o2 && o1.key == o2.key) {
      return o1.value;
    }
    else {
      return "";
    }
  }

}
